import { render, staticRenderFns } from "./GroupedSelectList.vue?vue&type=template&id=5f0b8887"
import script from "./GroupedSelectList.vue?vue&type=script&lang=js"
export * from "./GroupedSelectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports